import { useCallback, useState } from 'react';

import type { AnnotationData, AnnotationStyle } from '@/components/snapshot/annotation';

interface SnapshotAnnotationsState {
    /** All annotations for the current snapshot */
    annotations: AnnotationData[];
    /** Currently selected annotation id */
    selectedId: string | null;
    /** The selected annotation data (derived) */
    selectedAnnotation: AnnotationData | null;

    updateAnnotationStyle: (id: string, style: Partial<AnnotationStyle>) => void;
    setSelectedId: (id: string | null) => void;
    setAnnotations: (annotations: AnnotationData[]) => void;
}

export function useSnapshotAnnotations(): SnapshotAnnotationsState {
    const [annotations, setAnnotations] = useState<AnnotationData[]>([]);
    const [selectedId, setSelectedId] = useState<string | null>(null);

    const selectedAnnotation = annotations.find((a) => a.id === selectedId) ?? null;

    const updateAnnotationStyle = useCallback((id: string, style: Partial<AnnotationStyle>) => {
        setAnnotations((prev) =>
            prev.map((a) => (a.id === id ? ({ ...a, style: { ...a.style, ...style } } as AnnotationData) : a))
        );
    }, []);

    return {
        annotations,
        selectedId,
        selectedAnnotation,
        updateAnnotationStyle,
        setSelectedId,
        setAnnotations,
    };
}
